function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin-top: -10px;\n  margin-left: -20px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: 30px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React from 'react';
import PropTypes from 'prop-types';
import { Spin } from 'antd';
import styled from 'styled-components';
var LoaderWrapper = styled.div(_templateObject());
var LoaderContent = styled.div(_templateObject2());
/**
 * Loader component to display when fetching data and hot-loading components
 */

var Loader = () => /*#__PURE__*/React.createElement(LoaderWrapper, null, /*#__PURE__*/React.createElement(LoaderContent, null, /*#__PURE__*/React.createElement(Spin, {
  tip: "Loading..."
})));

export default Loader;